/* Reserveer de echte hoogte van de volgende kop plus een zichtbare strook productbeeld. */
(() => {
  const topbar = document.querySelector('section#top');
  const lineup = document.querySelector('#vuurkorven');
  const heading = lineup?.querySelector('.lineup-heading');
  const card = lineup?.querySelector('.product-card-link');
  const header = document.querySelector('.shopify-section--header');
  if (!lineup || !heading || !card) return;
  let frame;
  function measure() {
    frame = null;
    const viewport = document.documentElement.clientHeight;
    const hint = Math.min(96, Math.max(48, viewport * .08));
    const reserve = (topbar?.getBoundingClientRect().height || 0)
      + (header?.getBoundingClientRect().height || 0)
      + parseFloat(getComputedStyle(lineup).paddingTop)
      + heading.getBoundingClientRect().height
      + parseFloat(getComputedStyle(card).paddingTop) + hint;
    const minimum = (header?.getBoundingClientRect().height || 80) + 180;
    document.documentElement.style.setProperty('--hero-preview-height', `${Math.max(minimum, viewport - reserve)}px`);
  }
  function schedule() {
    if (frame == null) frame = requestAnimationFrame(measure);
  }
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', schedule);
  if ('ResizeObserver' in window) {
    const observer = new ResizeObserver(schedule);
    [topbar, heading, header].filter(Boolean).forEach(el => observer.observe(el));
  }
  document.fonts?.ready.then(schedule);
  schedule();
})();
